import React from "react";
import { Link } from "react-router-dom";
import BillingIcon from "../../assets/icons/icon_reporting_financials_white-01.svg2";
import SettingsIcon from "../../assets/icons/settings.svg2";

import InvoicingHistoryIcon from "../../assets/icons/invoice_history.svg2";
import PrepaidIcon from "../../assets/icons/prepaid.svg2";
import CalendarIcon from "../../assets/icons/calendar.svg2";
import BillingLinks from "./BillingLinks";
import PageHeader from "../Common/PageHeader";
import WhiteButton from "../Common/WhiteButton";
import BoomerangUiSalesIcon from "../../assets/icons/boomerang_element-01.svg2";
import SwitchAccountIcon from "../../assets/icons/switch_refresh.svg2";
import Subheading from "../Common/Subheading";
import MyIcon from "../Common/MyIcon";
import NewFeature from "../Builder/Components/NewFeature";
import HelpButton from "../HelpContent/HelpButton";
import WhiteButtonDropdown from "../Common/WhiteButtonDropdown";

export default function BillingStatus() {
  return (
    <div>
      <NewFeature>
        <div className="d-flex justify-content-between align-items-center">
          <Subheading
            Icon={SettingsIcon}
            heading="Billing Status"
            subheading="Your current real time financial usage."
          />
          <div>
            <WhiteButtonDropdown
              toggleHeading={"Actions"}
              toggleSubheading={"Billing Status"}
            >
              <WhiteButton
                as="RRLink"
                icon={SwitchAccountIcon}
                to="/switch-account"
                heading="Switch Account"
              />

              <WhiteButton
                as="RRLink"
                icon={BoomerangUiSalesIcon}
                to="/assets/contacts/fields"
                heading="Boomerang UI Sales"
              />
            </WhiteButtonDropdown>
          </div>
        </div>
        <div className="my-3 row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3">
          <div className="col">
            <div className="bg-white rounded-3 p-4 h-100 d-flex flex-column justify-content-between">
              <div>
                <h5 className="fw-bold">Full Account</h5>
                <hr className="border-secondary-subtle" />
              </div>
              <div className="d-flex align-items-center">
                <MyIcon Icon={PrepaidIcon} width={20} />

                <span className="mx-3">Postpaid</span>
              </div>
              <hr className="border-secondary-subtle" />
              <div className="d-flex align-items-start">
                <MyIcon Icon={InvoicingHistoryIcon} width={25} />
                <div className="mx-3">
                  <div>
                    You will receive an invoice for messaging activity in
                  </div>
                  <hr className="border-secondary-subtle" />
                  <div className="fs-1 fw-bold text-navy">15 Days</div>
                </div>
              </div>
              <button type="button" className="btn btn-colored-reverse w-100">
                VIEW ALL INVOICES
              </button>
            </div>
          </div>
          <div className="col">
            <div className="bg-white rounded-3 p-4 h-100 d-flex flex-column justify-content-between">
              <div>
                {" "}
                <h5 className="fw-bold">Message Bank</h5>
                <hr className="border-secondary-subtle" />
              </div>
              <div className="my-3">
                <div className="text-center fw-bold my-2">
                  <span className="text-navy">£10.00</span> spent of £30.00
                </div>
                <div
                  className="progress"
                  role="progressbar"
                  aria-label="Basic example"
                  aria-valuenow="75"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ height: 5 }}
                >
                  <div className="progress-bar w-75 bg-colored" />
                </div>
              </div>

              <hr className="border-secondary-subtle" />
              <div className="d-flex align-items-end">
                <div className="mx-3">
                  <div className="fs-1 fw-bold text-navy">£20.00</div>
                  <div>Credit remaining on account</div>
                </div>
              </div>
              <div className="" />
              <button type="button" className="btn btn-colored-reverse w-100">
                TOP UP CREDIT
              </button>
            </div>
          </div>
          <div className="col">
            <div className="bg-white rounded-3 p-4 h-100 d-flex flex-column justify-content-between">
              <div>
                <h5 className="fw-bold">Contract Period</h5>
                <hr className="border-secondary-subtle" />
              </div>
              <div className="my-3 text-center">
                <span className="fw-bold text-navy bg-purple-gradient rounded-pill py-2 px-3">
                  <CalendarIcon width={15} className="mx-2" /> 2 Years
                </span>
              </div>
              <hr className="border-secondary-subtle" />
              <div className="d-flex justify-content-between my-3">
                <div>
                  <div>Start date</div>
                  <div className="fs-5 fw-bold">7th Mar 2023</div>
                </div>
                <div>
                  <div>End date</div>
                  <div className="fs-5 fw-bold">7th Mar 2025</div>
                </div>
              </div>
              <div
                className="progress my-3 mb-5"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="75"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ height: 5 }}
              >
                <div className="progress-bar w-75 bg-colored" />
              </div>
              <button type="button" className="btn btn-colored-reverse w-100">
                SUBSCRIPTION DETAILS
              </button>
            </div>
          </div>
          <div className="col">
            <div className="bg-white rounded-3 p-4 h-100 d-flex flex-column justify-content-between">
              <div>
                <h5 className="fw-bold">boomStore</h5>
                <hr className="border-secondary-subtle" />
              </div>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Id sequi
              vero expedita culpa illum officia consectetur, magnam, ea repellat
              quaerat fugit exercitationem eos. Ipsam qui modi possimus nostrum,
              quam rerum!
              <hr className="border-secondary-subtle" />
              <button type="button" className="btn btn-colored-reverse w-100">
                VISIT boomStore
              </button>
            </div>
          </div>
        </div>
      </NewFeature>
    </div>
  );
}
